import { lazy } from 'react';

export const Vehicles = lazy(() => import('./ui/Vehicles'));
